import React from "react";
import {
  LayoutDashboard,
  Clock,
  PhoneCall,
  CheckCircle2,
  XCircle,
  PoundSterling,
} from "lucide-react";

const StatCard = ({ label, value, icon: Icon, color, subtext }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-md transition-shadow duration-200">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm font-medium text-slate-500">{label}</p>
        <p className="text-3xl font-bold text-slate-900 mt-1">{value}</p>
        {subtext && <p className="text-xs text-slate-400 mt-1">{subtext}</p>}
      </div>
      <div className={`w-11 h-11 rounded-lg flex items-center justify-center ${color}`}>
        <Icon className="w-5 h-5" />
      </div>
    </div>
  </div>
);

const AdminStatsBar = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      <StatCard
        label="Total Quotes"
        value={stats.total}
        icon={LayoutDashboard}
        color="bg-slate-100 text-slate-600"
      />
      <StatCard
        label="Pending"
        value={stats.pending}
        icon={Clock}
        color="bg-amber-100 text-amber-600"
        subtext="Awaiting response"
      />
      <StatCard
        label="Contacted"
        value={stats.contacted}
        icon={PhoneCall}
        color="bg-sky-100 text-sky-600"
      />
      <StatCard
        label="Booked"
        value={stats.booked || 0}
        icon={PhoneCall}
        color="bg-violet-100 text-violet-600"
      />
      <StatCard
        label="Completed"
        value={stats.completed}
        icon={CheckCircle2}
        color="bg-green-100 text-green-600"
      />
      <StatCard
        label="Cancelled"
        value={stats.cancelled}
        icon={XCircle}
        color="bg-red-100 text-red-600"
      />
      <StatCard
        label="Revenue"
        value={`£${stats.estimated_revenue}`}
        icon={PoundSterling}
        color="bg-sky-100 text-sky-600"
        subtext="From completed"
      />
    </div>
  );
};

export default AdminStatsBar;
